module.exports = __webpack_public_path__ + "img/tarj2-5.2e5a44b0.svg";